import { Checkbox, CheckboxProps, Flex } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'

export const CheckAll = (props: CheckboxProps) => {
  const msg = useMsg()
  return (
    <Flex h={10} align="center">
      <Checkbox size="lg" m={0} aria-label={msg('common.ui.select_all')} {...props} />
    </Flex>
  )
}
